import {
  useParams,
  useSearchParams,
} from "react-router-dom"

import { hasExactIdentifier } from "@/lib/exact-search"
import { DateHelper } from "@/utils"
const useSubscriptionsSearchParams = () => {
  const routeParams = useParams()
  const [searchParams] = useSearchParams()
  // Sem filtro na URL, a tela abre no dia de hoje — não numa janela retroativa..
  const stringStartDate = DateHelper.currentDate()
  const stringEndDate = DateHelper.currentDate()
  const quantity = searchParams.get("quantity") || "10"
  const customerDocument =
    searchParams.get("customerDocument") || undefined
  const code =
    searchParams.get("code") ||
    (routeParams.code as string) ||
    undefined

  // Mesma regra da lista de pedidos: com identificador exato o período não é reposto aqui.
  const searchesByIdentifier = hasExactIdentifier({
    customerDocument,
    code,
  })

  const params: SubscriptionsSearchParamsType = {
    from:
      searchParams.get("from") ||
      (searchesByIdentifier ? undefined : stringStartDate),
    to:
      searchParams.get("to") ||
      (searchesByIdentifier ? undefined : stringEndDate),
    page: searchParams.get("page") || "1",
    pageSize: searchParams.get("pageSize") || quantity,
    code,
    status: searchParams.get("status") || undefined,
    paymentMethod:
      searchParams.get("paymentMethod") || undefined,
    customerDocument,
    refetch: searchParams.get("refetch") || undefined,
  }
  return {
    params,
  }
}
export default useSubscriptionsSearchParams
